import { Component, OnInit, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalNotifierService, GlobalInfoService, AuthenticationService } from '@app/core';
import { ActividadCalendario, BaseControl, ConfirmComponent } from '@app/shared';

import { CalendarioDinamico, CalendarService } from './shared/calendar.service';
import { BsModalRef } from 'ngx-bootstrap';
import { CalendarConfig } from './shared/calendar.config.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { LocalDataSource } from 'ng2-smart-table';
import { CalendarFormService } from './shared/calendar.forms.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { environment } from '@env/environment';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'iw-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
  providers: [
    CalendarService,
    CalendarFormService,
    DatePipe
  ]
})
export class CalendarComponent implements OnInit, OnDestroy {
  // Define cuando se esta cargando el calendario de actividades
  isLoading = false;
  // controles dinamicos de el formulario
  controls: BaseControl<any>[] = [];
  // informacion del calendario
  calendarData: ActividadCalendario[] = [];
  // Datos de la tabla
  data: Array<any> = [];
  // Datos para llenar la tabla
  sourceData: LocalDataSource;
  // Configuración de la tabla
  settings = {};
  // Referencia de la modal
  modalRef: BsModalRef;
  // Contiene la data de la fila seleccionada
  rowData: ActividadCalendario;
  // Datos del formulario
  dataReject: any;
  // Variable que define si se muestra únicamente el calendario principal o se muestra el selector
  // de calendarios disponibles
  dynamic_calendar = environment.calendario_dinamico;
  dynamic_calendar_unique = environment.calendario_dinamico_unico;
  // lista de calendarios disponibles
  calendarList: CalendarioDinamico[] = [];
  //Modelo para las configuraciones de la tabla
  calendarSettings = {};
  // Variable para el calendario seleccionado
  calendarModel: any = {};
  // datos para llenar la variable de la tabla
  calendarSourceData: any[] = [];
  //Datos para llenar la tabla
  source: LocalDataSource;
  // calendario seleccionado
  selectedCalendar: CalendarioDinamico = {};
  // controla que cuando la tabla tiene documento y se dé click en descargar
  downloadingDocument: boolean = false;
  // controla que cuando la tabla tiene documento y se dé click en previsualizar, no se pase al trámite directamente
  previewDocument: boolean = false;
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Modal de formulario de rechazo de tarea
  @ViewChild('templateReject') private templateReject: TemplateRef<any>;
  // Modal de acciones a la tarea asignada
  @ViewChild('templateAccion') private templateAccion: TemplateRef<any>;
  // Referencia al componente de confirmación
  @ViewChild('confirmAction') private confirmAction: ConfirmComponent;
  // Referencia al template de la modal de visualizacion de documento
  @ViewChild('templatePreviewDoc') private templatePreviewDoc: TemplateRef<any>;

  constructor(
    private router: Router,
    private cs: CalendarService,
    private gns: GlobalNotifierService,
    private gis: GlobalInfoService,
    private as: AuthenticationService,
    private modalService: BsModalService,
    private cfs: CalendarFormService,
    private toastr: ToastrService,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    // Actualizar título de la vista
    this.gis.set({ title: 'Calendario de actividades' });
    // Cargar el calendario de actividades
    if(this.dynamic_calendar || this.dynamic_calendar_unique){
      this.cs.getAvailableCalendar().subscribe(async calendar=>{
        this.calendarList = await calendar;
        if(this.dynamic_calendar_unique){
          this.loadCalendar();
        }
      }, err=>{
        this.calendarList = [];
      })
    }else{
      this.loadCalendar();
    }
    this.source = new LocalDataSource(this.calendarSourceData);
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Controla el evento clic en la fila de la tabla.
   *
   * @param {any} row
   * @memberof CalendarComponent
   */
  onCellClick(row: any) {
    if(!this.downloadingDocument && !this.previewDocument){
    this.rowData = row.data;
    this.modalRef = this.modalService.show(this.templateAccion, { class: 'modal-lg'});
    }
  }

  /**
   * Consulta el tramite seleccionado.
   *
   * @param {*} row
   * @memberof CalendarComponent
   */
  goTask() {
    this.modalRef.hide();
    this.gns.set<ActividadCalendario>({
      source: 'CalendarComponent',
      destiny: 'FlowComponent',
      action: 'showFlow',
      eventTriggered: 'click',
      data: <ActividadCalendario>this.rowData
    }, true);
    this.router.navigate(['/home']);
  }

  /**
   * Abre el modal de rechazo de tarea
   *
   * @param {ActividadCalendario} data
   * @memberof CalendarComponent
   */
  openModalReject() {
    if (this.rowData.rechazable) {
      this.controls = this.cfs.getFormReject();
      this.modalRef.hide();
      this.modalRef = this.modalService.show(this.templateReject, { class: 'modal-lg'});
    } else {
      this.toastr.warning(
        'No es posible realizar esta acción ya que la tarea no puede ser rechazada',
        'Acción no permitida'
      );
    }
  }

  /**
   * Abre el modal de confirmacion para el rechazo
   *
   * @param {*} data
   * @memberof CalendarComponent
   */
  confirm(data: any) {
    this.dataReject = data;
    this.confirmAction.open();
  }

  /**
   * Controla la accion de la confirmacion en el rechazo
   *
   * @param {*} res
   * @memberof CalendarComponent
   */
  action(res: any) {
    if (res) {
      this.cs.rejectTask(this.rowData.id, this.dataReject.txtMotivo).subscribe(resR => {
        if (resR) {
          this.loadCalendar();
          this.modalRef.hide();
        }
      });
    }
    this.dataReject = null;
  }

  /**
   * Realiza la consulta de las actividades asignadas por usuario en sesion
   *
   * @private
   * @memberof CalendarComponent
   */
  private loadCalendar() {
    if(this.dynamic_calendar){
      this.changeCalendar(this.selectedCalendar.id);
    }else if(this.dynamic_calendar_unique){
      this.LoadCalendarUnique();
    }else{
      const user = this.as.getCredentials();
      this.isLoading = true;
      this.data = [];
      this.cs.getDataCalendar(user.user_id).then(data => {
        this.calendarData = data;
        this.loadDinamicFieldFromTable();
      }).catch(() => {
        // Se inicia la configuracion de la tabla
        const configTable = new CalendarConfig();
        this.settings = configTable.settings;
        this.calendarData = [];
        this.loadTableActivities();
      });
    }
  }

  /**
   * Genera los campos dinamicos de el calendario de actividades en la tabla
   *
   * @private
   * @memberof CalendarComponent
   */
  private loadDinamicFieldFromTable() {
    const configTable = new CalendarConfig();
    this.settings = {};
    if (this.calendarData && this.calendarData.length) {
      if (this.calendarData[0].campos && this.calendarData[0].campos.length) {
        this.calendarData.forEach(cd => {
          cd.campos.sort((a, b) => a.orden - b.orden);
        });
        this.calendarData[0].campos.forEach(field => {
          configTable.generateColumn(field.orden + ' ', field.nombre_parametro);
        });
      }
    }
    this.settings = configTable.settings;
    this.loadTableActivities();
  }

  /**
   * Carga la informacion de cada tarea asignada para ser visaulizada en la tabla de calendario
   *
   * @private
   * @memberof CalendarComponent
   */
  private loadTableActivities() {
    this.data = [];
    if (this.calendarData && this.calendarData.length) {
      this.calendarData.forEach(activity => {
        const d = {};
        Object.keys(activity).forEach(key => {
          if (key !== 'campos') {
            d[key] = activity[key];
          }
        });
        if (activity.campos && activity.campos.length) {
          activity.campos.forEach(field => {
            d[field.orden + ' '] = field.valor;
            if (field['formato_fecha']) {
              d['formato_fecha'] = field['formato_fecha'];
            }
          });
        }
        this.data.push(d);
      });
    }
    this.sourceData = new LocalDataSource(this.data);
    this.sourceData.refresh();
    this.isLoading = false;
  }

  /**
   *Maneja los cambios ene el selector de calendario
   *
   * @param {*} data
   * @memberof CalendarComponent
   */
  changeCalendar(data: any){
    if(data!==null){
      this.calendarSourceData = [];
      this.isLoading = true;
      this.selectedCalendar = {};
      this.calendarList.forEach(calendar=>{
        if(data == calendar.id){
          this.selectedCalendar = calendar;
          calendar.estructura.sort(function (a, b) {
            if (a.orden > b.orden) {
              return 1;
            }
            if (a.orden < b.orden) {
              return -1;
            }
            return 0;
          });
          const configTable = new CalendarConfig(calendar);
          this.settings = configTable.dynamicSettings;
          configTable.accion.subscribe((res: any) => {
            switch (res.action) {
              case "descargar":
                this.downloadingDocument = true;
                this.download('documento', res.data.id_documento);
                break;
              case "preview_documento":
                this.previewDocument = true;
                let id_doc_preview = res.id_documento_preview ? res.id_documento_preview : (res.data && res.data.id_documento_preview) ? res.data.id_documento_preview : null;
                this.preview(id_doc_preview)
                break;
              default:
                break;
            }
          });
          this.cs.getCalendarData(calendar.id).subscribe(async res=>{
            this.calendarSourceData = await res;
            this.calendarSourceData.forEach(c=>{
              if(c.fecha_asignacion){
                c.fecha_asignacion = this.datePipe.transform(c.fecha_asignacion, 'yyyy-MM-dd')
              }
            })
            this.source = new LocalDataSource(this.calendarSourceData);
            this.isLoading = false;
          }, err=>{
            this.isLoading = false;
          })
        }
      });
    }else{
      this.calendarSourceData = [];
      this.selectedCalendar = {};
    }
  }
  /**
   *Maneja los cambios sobre el calendario dinamico unico
   *
   * @param {*} data
   * @memberof CalendarComponent
   */
   LoadCalendarUnique(){
      this.calendarSourceData = [];
      this.isLoading = true;
      this.selectedCalendar = {};
      this.calendarList.forEach(calendar=>{
        if(calendar.nombre == "_unico_"){
          this.selectedCalendar = calendar;
          calendar.estructura.sort(function (a, b) {
            if (a.orden > b.orden) {
              return 1;
            }
            if (a.orden < b.orden) {
              return -1;
            }
            return 0;
          });
          const configTable = new CalendarConfig(calendar);
          this.settings = configTable.dynamicSettings;
          configTable.accion.subscribe((res: any) => {
            switch (res.action) {
              case "descargar":
                this.downloadingDocument = true;
                this.download('documento', res.data.id_documento);
                break;
              case "preview_documento":
                this.previewDocument = true;
                let id_doc_preview = res.id_documento_preview ? res.id_documento_preview : (res.data && res.data.id_documento_preview) ? res.data.id_documento_preview : null;
                this.preview(id_doc_preview)
                break;
              default:
                break;
            }
          });
          this.cs.getCalendarData(calendar.id).subscribe(async res=>{
            this.calendarSourceData = await res;
            this.calendarSourceData.forEach(c=>{
              if(c.fecha_asignacion){
                c.fecha_asignacion = this.datePipe.transform(c.fecha_asignacion, 'yyyy-MM-dd')
              }
            })
            this.source = new LocalDataSource(this.calendarSourceData);
            this.isLoading = false;
          }, err=>{
            this.isLoading = false;
          })
        }
      });
  }

  download(type_document: string, document_id: number){
    if(type_document == 'documento'){
      this.cs.dowloadFile(document_id).subscribe((res: any) => {
        const a = document.createElement('a');
        a.target = '_blank';
        a.href = res.file.path;
        a.download = res.file.name;
        a.click();
        a.remove();
        this.downloadingDocument = false;
      }, err=>{
        this.downloadingDocument = false;
      });
    }
  }

  preview(document_id: number){
    if(document_id){
      this.cs.dowloadFile(document_id).subscribe((res: any) => {
        this.modalRef = this.modalService.show(this.templatePreviewDoc, { class:  'modal-personalized', initialState: res.file});
        let type = res.file.path.split(".").pop();
        let document = {"tipo": type, "ruta": res.file.path, "rutaGoogle": "https://docs.google.com/gview?url="+ res.file.path+"&embedded=true",
        "rutaMicrosoft":"https://view.officeapps.live.com/op/view.aspx?src="+res.file.path+"&wdOrigin=BROWSELINK"} 
        this.modalRef.content = document;
        this.previewDocument = false;
      }, err=>{
        this.previewDocument = false;
      });
    }
  }

  closeModalPreviewDoc() {
    this.modalRef.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/calendar/calendar.component.ts